import SvgIcon from '@mui/material/SvgIcon';

export default function BjeIconSmall(props) {
  const fillColor = "#009ee2"
  
  return (
    <SvgIcon
      width={props.width}
      height={props.height}
      viewBox="0 0 86 204"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
      sx={{
        width: props.width,
        height: props.height,
      }}
    >
      <path style={{fill: fillColor}} d="M43,0C19.29,0,0,19.29,0,43c0,15.99,9.38,31.07,23.89,38.42,1.67.92,3.33,1.39,4.93,1.39,1.41,0,2.73-.37,3.92-1.1,2.52-1.55,4.08-4.51,3.97-7.53-.12-3.07-1.92-5.66-5.07-7.29-6.96-4.17-14.42-12.64-14.42-23.85,0-14.54,11.32-25.93,25.78-25.93s26.5,11.63,26.5,25.93c0,9.96-5.85,19.25-14.93,23.75l-.28.14c-4.2,2.4-5.08,5.36-5.08,7.48,0,2.99,1.83,6.03,4.55,7.57.82.46,2.13,1.01,3.74,1.01,1.37,0,2.73-.4,4.03-1.18l.12-.07c14.78-7.1,24.34-22.31,24.34-38.74C86,19.29,66.71,0,43,0ZM57.51,82.73s-.01,0-.02,0c.03,0,.05,0,.08,0-.02,0-.04,0-.06,0Z"/>
      <path style={{fill: fillColor}} d="M.18,101.14c0,5.1,4.11,9.25,9.16,9.25h67.52c5.05,0,9.16-4.15,9.16-9.25s-4.11-9.25-9.16-9.25H9.34c-5.05,0-9.16,4.15-9.16,9.25Z"/>
      <path style={{fill: fillColor}} d="M24.51,179.94c4.34,7.43,8.44,14.45,11.95,20.58,1.55,2.25,3.97,3.53,6.59,3.48,2.5-.03,4.77-1.27,6.07-3.3l35.35-60.25c1.01-1.9,1.52-3.89,1.52-6.05,0-7.17-5.9-13-13.14-13h-15.73c-4.58,0-8.3,3.72-8.3,8.3s3.72,8.16,8.3,8.16h9.96l-24.71,40.25-23.34-40.25h9.88c4.58,0,8.3-3.66,8.3-8.16s-3.72-8.3-8.3-8.3h-15.73C5.95,121.41.07,127.19.02,134.33c.44,4.39,1.54,6.21,4.17,10.57.91,1.51,20.32,35.04,20.32,35.04Z"/>
    </SvgIcon>
  );
}

BjeIconSmall.defaultProps = {
  color: '#00ACEC',
  width: '13px',
  height: '32px',
};